export default "__VITE_ASSET__CqNvSV4W__"